// Media Queries
const mqSizes = {
  sm: 768,
  md: 1024,
  lg: 1200
};

export const device = Object.keys(mqSizes).reduce((acc, cur) => {
  acc[cur] = `(min-width: ${mqSizes[cur]}px)`;
  return acc;
}, {});

// Colors
export const colors = {
  white: `#ffffff`,
  lightGrey: `#aaa`,
  grey: `#666`,
  mediumBlue: `#185674`,
  darkBlue: `#263645`,
  orange: `#d1461c`,
  orangeDark: `#bb2e00`,
  warning: `#d1461c`,
  background: `#061016`
};

// Font Stacks:
export const fonts = {
  museo: `"museo-sans", "Museo Sans", "Helvetica", "Arial", sans-serif`,
  brandon: `"brandon-grotesque", "Brandon Grotesque", "Helvetica", "Arial", sans-serif`
};

// Font Weights:
export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
};
